import apiFetch from '../apiFetch'

export default function ({dosisReales, volumenTipoDosis, codVerraco, nombreRaza, fechaExtraccion, volumenDiluyente, idAnalisisExtraccion}) {
  return apiFetch({
    endPoint: `Analisis/generarPDFEtiqueta?dosisReales=${dosisReales}&volumenTipoDosis=${volumenTipoDosis}&codVerraco=${codVerraco}&nombreRaza=${nombreRaza}&fechaExtraccion=${fechaExtraccion}&volumenDiluyente=${volumenDiluyente}&idAnalisis=${idAnalisisExtraccion}`,
    method: 'GET', body: null, token: null
  })
}